const COMMON_ERRORS = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  "Can't find variable: googleFormValidation",
  'googleFormValidation is not defined',
  'Could not load "util"', // google maps https://issuetracker.google.com/issues/370804667?pli=1
  'Failed to load script',
  "Failed to execute 'removeChild'",
  'ChunkLoadError',
  'Loading chunk',
  'HierarchyRequestError',
  '(type=error) captured as promise rejection', // This is a bug with the server dc
  `Unexpected token '.'`,
  'Unexpected token .',
  'NetworkError when attempting to fetch resource.',
  /UnknownError: Connection to Indexed Database server lost. Refresh the page to try again/,
  "ReferenceError: Can't find variable: gmo",
  'Method not found',
  'Blocked a frame with origin',
  `(reading 'domInteractive')`,
  'this.shouldEnforce',
  'The user with the provided phone number already exists',
  'Timeout: MP_DEVICE_SESSION_ID not found',
  'AggregateError: No error message',
  `Unexpected token '<'`,
  `undefined is not an object (evaluating 'window.webkit.messageHandlers[e].postMessage')`, // Facebook webview
  'TypeError [ERR_INVALID_STATE]: Invalid state: Unable to enqueue',
  /ERR_INVALID_STATE.*Unable to enqueue/,
  'QuotaExceededError',
]

const FIREBASE_AUTH_ERRORS = [
  /\(auth\/invalid-credential\)/i,
  /\(auth\/user-not-found\)/i,
  /\(auth\/cancelled-popup-request\)/i,
  /\(auth\/wrong-password\)/i,
  /\(auth\/email-already-in-use\)/i,
  /\(auth\/popup-closed-by-user\)/i,
  /\(auth\/unauthorized-continue-uri\)/i,
  /\(auth\/missing-email\)/i,
  /\(auth\/too-many-requests\)/i,
  /\(auth\/invalid-login-credentials\)/i,
  /\(auth\/network-request-failed\)/i,
  `Database deleted by request of the user`,
  'Firebase: Missing password requirements',
  'INTERNAL ASSERTION FAILED: Pending promise was never set',
  `DataCloneError`,
]

const DATABASE_STORAGE_ERRORS = [
  /Database query failed: /,
  /Failed to save data to local storage/i,
]

const SERVICE_UNAVAILABLE_ERRORS = [
  /Service unavailable: /,
  /Service is currently down for maintenance/i,
  'ApolloError: Load failed',
  'ApolloError: Failed to fetch',
]

const PERMISSION_ERRORS = [
  /Permission denied: /,
  /User not authorized to perform action: /,
  'Must authenticate',
  'UNAUTHORIZED',
  `Cannot read property 'click' of null`,
  'SecurityError: Failed to read a named property',
]

const ignoreErrors = [
  ...COMMON_ERRORS,
  ...FIREBASE_AUTH_ERRORS,
  ...DATABASE_STORAGE_ERRORS,
  ...PERMISSION_ERRORS,
  ...SERVICE_UNAVAILABLE_ERRORS,
]

export default ignoreErrors
